import { useRef, useState } from "react";
import Drop from "./Drop";
import { Document, Page, pdfjs } from "react-pdf";
import { PDFDocument, rgb, scale } from "pdf-lib";
import { blobToURL } from "../../utils/util";
import PagingControl from "./PagingControl";
import { AddSigDialog } from "./AddSigDialog";
import BigButton from "./BigButton";
import DraggableSignature from "./DraggableSignature";
import DraggableText from "./DraggableText";
import dayjs from "dayjs";
import React from "react";
import { Upload } from "../../utils/Upload";
import {uploadBackend } from '../../utils/Upload';
import { approvalPolicy, updateUserPolicy } from "../../service/todo";
import { encryptStorage } from "../../constant";
import { RejectPopup } from "./RejectComments/RejectPopup";
import { Modal } from "./Modal";

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
//let blink = document.createElement("a");

export function Sign({ doc, End, policyId, view, sign, userType, policyname,freeze,preSignedURL }) {

  const [pdf, setPdf] = useState(doc);
  const [signatureURL, setSignatureURL] = useState(null);
  const [position, setPosition] = useState(null);
  const [signatureDialogVisible, setSignatureDialogVisible] = useState(false);
  const [textInputVisible, setTextInputVisible] = useState(false);
  const [pageNum, setPageNum] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [pageDetails, setPageDetails] = useState(null);
  const documentRef = useRef(null);
  const [uploadSign, setUploadSign] = useState(null);
  const [scales, setScales] = useState(1);
  const [showSubmit, setShowSubmit] = useState(false);
  const [checked, SetChecked] = useState(false);
  const [rejectPopUp, setRejectPopUp] = useState(false);
  let ref = useRef();
  let type = ""

  const styles = {
    container: {
      maxWidth: "100%",
      margin: "0 auto"
    },
    sigBlock: {
      display: "inline-block",
      border: "1px solid #000"
    },
    documentBlock: {
      maxWidth: "75%",
      margin: "20px auto",
      marginTop: 8,
      border: "1px solid #999",
    },
    controls: {
      marginTop: '35px',
      marginLeft: '25%',
      maxWidth: "100%"
    },
  };

  let annotation = document.getElementsByClassName('react-pdf__Page__annotations annotationLayer');
  let text = document.getElementsByClassName('react-pdf__Page__textContent textLayer');

  const renderResults = () => {

    return (
      <div style={{ background: "#000", height: "700px", right: 0, opacity: "0.7", marginTop: "-35px" }}>
        <div style={styles.container}>
          {signatureDialogVisible && !view ? (
            <AddSigDialog
              onClose={() => setSignatureDialogVisible(false)}
              onConfirm={(url) => {
                setSignatureURL(url);
                setSignatureDialogVisible(false);
              }}
            />
          ) : null}

          {rejectPopUp ?
            <RejectPopup
              policyId={policyId}
              onClose={(result) => {
                if (result) {
                  SetChecked(false);
                  End();
                  setRejectPopUp(false)
                }
                else {
                  setRejectPopUp(false)
                }
              }} /> : <></>}

          {rejectPopUp ?
            <RejectPopup
              policyId={policyId}
              onClose={(result) => {
                if (result) {
                  End();
                  setRejectPopUp(false)
                }
                else {
                  setRejectPopUp(false)
                }
              }} /> : <></>}

          {!pdf && !view ? (
            <Drop
              onLoaded={async (files) => {
                const URL = await blobToURL(files[0]);
                setPdf(URL);
              }}
            />
          ) : null}

          <div>
            <div style={styles.controls}>
              <div>
                <div style={{
                  marginTop: "1%",
                  marginBottom: 8,
                }}>
                  {/* //PC_FG_05 */}
                  <div style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center'
                  }}>
                    <p style={{ color: "white", marginLeft: "-300px", fontFamily: "SF Pro Bold", fontSize: "20px" }} className="mt-5 me-5">{policyname}</p>
                  </div>
                </div>
              </div>
            </div>
            <div ref={documentRef} style={styles.documentBlock}>
              {textInputVisible && !view ? (
                <DraggableText
                  //PC_FG_31 onclick cancel the input field is hiddem
                  onCancel={() => setTextInputVisible(false)}
                  //PC_FG_32
                  onEnd={setPosition}
                  //PC_FG_33 The function is called while inserting the text into the pdf
                  //which is after clicking the tick button
                  onSet={async (text) => {
                    //PC_FG_34
                    const { originalHeight, originalWidth } = pageDetails;
                    const scale =
                      originalWidth / documentRef.current.clientWidth;

                    //PC_FG_35
                    const y =
                      documentRef.current.clientHeight -
                      (position.y +
                        12 * scale -
                        position.offsetY -
                        documentRef.current.offsetTop);
                    const x =
                      position.x -
                      (freeze ? 150 : 159) -
                      position.offsetX -
                      documentRef.current.offsetLeft;
                    // new XY in relation to actual document size
                    //PC_FG_36
                    const newY =
                      (y * originalHeight) / documentRef.current.clientHeight;
                    const newX =
                      (x * originalWidth) / documentRef.current.clientWidth;

                    // Fetch the existing PDF file
                    //PC_FG_37

                    const response = await fetch(pdf);
                    const existingPdfBytes = await response.arrayBuffer();
                    const pdfDoc = await PDFDocument.load(existingPdfBytes);

                    //PC_FG_38
                    const pages = pdfDoc.getPages();
                    const firstPage = pages[pageNum];

                    //PC_FG_39
                    firstPage.drawText(text, {
                      x: newX,
                      y: newY,
                      size: 20 * scale
                    });

                    //PC_FG_40
                    const pdfBytes = await pdfDoc.save();
                    const blob = new Blob([new Uint8Array(pdfBytes)]);

                    //PC_FG_41
                    const URL = await blobToURL(blob);
                    setPdf(URL);
                    setPosition(null);
                    setTextInputVisible(false);
                  }}
                />
              ) : null}

              {/* //PC_FG_65 */}
              {signatureURL && !view ? (
                <DraggableSignature
                  //PC_FG_66
                  url={signatureURL}
                  //PC_FG_67
                  onCancel={() => {
                    setSignatureURL(null);
                  }}
                  //PC_FG_68
                  onSet={async () => {
                    //PC_FG_69
                    const { originalHeight, originalWidth } = pageDetails;
                    const scale =
                      originalWidth / documentRef.current.clientWidth;

                    const y =
                      documentRef.current.clientHeight -
                      (position.y -
                        position.offsetY +
                        50 -
                        documentRef.current.offsetTop);
                    const x =
                      position.x -
                      80 -
                      position.offsetX -
                      documentRef.current.offsetLeft;
                    // new XY in relation to actual document size
                    const newY =
                      (y * originalHeight) / documentRef.current.clientHeight;
                    const newX =
                      (x * originalWidth) / documentRef.current.clientWidth;


                    //PC_FG_70
                    // Fetch the existing PDF file
                    const response = await fetch(pdf);
                    const existingPdfBytes = await response.arrayBuffer();
                    const pdfDoc = await PDFDocument.load(existingPdfBytes);

                    const pages = pdfDoc.getPages();
                    const firstPage = pages[pageNum];

                    const res = await fetch(signatureURL);
                    const imageBytes = await res.arrayBuffer();

                    //PC_FG_71
                    const pngImage = await pdfDoc.embedPng(imageBytes);
                    let pngDims = "";
                    pngDims = pngImage.scale(scale * 0.3);

                    firstPage.drawImage(pngImage, {
                      x: newX,
                      y: newY,
                      width: pngDims.width,
                      height: pngDims.height
                    });

                    ;
                    //PC_FG_72
                    const pdfBytes = await pdfDoc.save();
                    const blob = new Blob([new Uint8Array(pdfBytes)]);

                    //PC_FG_73
                    const URL = await blobToURL(blob);

                    setPdf(URL);
                    setPosition(null);
                    setSignatureURL(null);
                  }}
                  //PC_FG_74
                  onEnd={setPosition}
                />
              ) : null}
               <div style={{ overflowY: 'auto', height: '400px' }}>
              <Document
                //PC_FG_12
                file={pdf}
                //PC_FG_13
                onLoadSuccess={(data) => {
                  setTotalPages(data.numPages);
                }}
              >
                 
           <Page
           //PC_FG_14
           pageNumber={pageNum + 1}
           //PC_FG_15
           height={600}
           width={600}
           //PC_FG_16
           onLoadSuccess={(data) => {
             //PC_FG_17
             setPageDetails(data);
             if (annotation[0].style != undefined && text[0].style != undefined) {
               annotation[0].style.display = "none";
               text[0].style.display = "none";
             }
           }}
           //PC_FG_18
           canvasRef={ref}
           //PC_FG_19
           size="A4"
           //PC_FG_20
           scale={1.75}
         />
      
                {/* PC_FG_13 */}
               
              </Document></div>
            </div>
            <div >
              <PagingControl
                pageNum={pageNum}
                setPageNum={setPageNum}
                totalPages={totalPages}
                policyname={policyname}
                view={view}
                isChecked={(e) => {
                  SetChecked(e)
                }}
              />
            </div>
            <div style={{ marginLeft: "180px" }}>
              {!signatureURL && userType != "approver" && !view && sign ? (
                <BigButton
                  marginRight={8}
                  title={"Add signature"}
                  onClick={() =>
                    setSignatureDialogVisible(true)}
                />
              ) : null}

              {!view ?
                (userType != "approver" ?
                  (sign ?
                    <BigButton
                      marginRight={8}
                      title={"Add Text"}
                      onClick={() => setTextInputVisible(true)}
                    /> : <></>) : <BigButton
                    disabled={!checked}
                    //PC_FG_77
                    marginRight={8}
                    //PC_FG_78
                    title={"Reject"}
                    //PC_FG_79
                    onClick={async () => {
                      setRejectPopUp(true);
                    }}
                  />)
                : <></>}


              {(userType != "approver" && !view && sign ?
                <div style={{ position: 'relative', display: 'inline-block' }}>
                  <label htmlFor="salary-Revision" className="goalform-custom-file-upload">
                    <img className="me-2" src="Images/profile-upload-icon.svg" alt="Upload Icon" />
                    Upload Signature
                  </label>

                  <input
                    id="salary-Revision"
                    type="file"
                    className="profile-file-upload"
                    name="attachement_url"
                    onChange={async (e) => {
                      let URL = await blobToURL(e.target.files[0]);
                      if (URL.startsWith("image/")) {
                        type = "image";
                        setSignatureURL(URL)
                      } else {
                      }
                    }}
                  />
                  <label className="hive-form-mandatory" />
                </div> : <></>)}

              {userType == 'approver' ?
                (<BigButton
                  //PC_FG_77
                  marginRight={8}
                  disabled={!checked}
                  //PC_FG_78
                  title={"Approve"}
                  //PC_FG_79
                  onClick={async () => {
                    //PC_FG_80
                    let update = await approvalPolicy({
                      approverAction: "approved",
                      comments: "",
                      approverId: encryptStorage.getItem("secAudits") ?
                        "Sec Audits" :
                        encryptStorage.getItem("employeeId"),
                      policyId: policyId,
                    })
                    SetChecked(false);
                    //PC_FG_81.5
                    End("Done")
                  }} />) : <></>
              }
              {userType != "approver" && !freeze ?
                <button onClick={() => { End() }} type="button" class="btn cancel-button btn-link text-white shadow-none font-14 bold-text px-3 me-3" style={{ marginLeft: "353px" }}>
                  Remind Me Later
                </button> : <></>}
              {/* //PC_FG_23 */}
              {pdf && userType != "approver" && !view ? (
                <BigButton
                  //PC_FG_24
                  marginRight={8}
                  inverted={true}
                  title={"Submit"}
                  disabled={!checked}
                  //PC_FG_25
                  onClick={async () => {
                    try {
                      ;
                      //PC_FG_26
                      let policyURL = "";
                      if(sign){
                      const base64Data = pdf.split(',')[1];
                      const binaryData = atob(base64Data);
                   
                      // Convert binary data to Uint8Array
                      const arrayBuffer = new Uint8Array(binaryData.length);
                      for (let i = 0; i < binaryData.length; i++) {
                        arrayBuffer[i] = binaryData.charCodeAt(i);
                      }
                      let dirName = `sign-policy`;
                      // Create a Blob object from Uint8Array
                      const blobq = new Blob([arrayBuffer], { type: 'application/pdf' });
                      policyURL = await uploadBackend(blobq, "Policy.pdf", dirName);
                      // let policyURL = await Upload(file, "Policy.pdf");
                    }
                      //PC_FG_27
                      let update = await updateUserPolicy({
                        signedPolicyUrl: sign ? policyURL?.location : preSignedURL,
                        acknowledgementStatus: true,
                        employeeId: encryptStorage.getItem('employeeId'),
                        policyId: policyId,
                      })
                      SetChecked(false);
                      //PC_FG_28.5 To set close the popup
                      End("Done")
                    }
                    catch (error) {
                      console.log(error.message);
                    }
                  }}
                />
              ) : null}
            </div>
          </div>
        </div>
      </div>
    );
  }

  return <div>{renderResults()}</div>;
}

function downloadURI(uri, name) {
  var link = document.createElement("a");
  link.download = name;
  link.href = uri;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

export default Sign;
